import { useLocation, useNavigate } from "react-router-dom";
import { Trophy, Award } from "lucide-react";

export const BottomTab = () => {
  const nav = useNavigate();
  const loc = useLocation();
  const rankingActive = loc.pathname.startsWith("/ranking");
  const eventiActive = !rankingActive;

  const Item = ({ active, icon: Icon, label, onClick, testid }) => (
    <button
      data-testid={testid}
      onClick={onClick}
      className="flex-1 flex flex-col items-center justify-center gap-1 py-2 transition-colors"
    >
      <Icon size={26} strokeWidth={2.2} className={active ? "text-onsurface" : "text-onsurface3"} />
      <span className={`text-xs font-bold ${active ? "text-onsurface" : "text-onsurface3"}`}>{label}</span>
    </button>
  );

  return (
    <nav
      data-testid="bottom-tab-bar"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-surface2 border-t border-surface3 flex z-40"
      style={{ paddingBottom: "var(--safe-bottom)" }}
    >
      <Item active={eventiActive} icon={Trophy} label="Eventi" testid="tab-eventi" onClick={() => nav("/")} />
      <Item active={rankingActive} icon={Award} label="Ranking" testid="tab-ranking" onClick={() => nav("/ranking")} />
    </nav>
  );
};
